import {Box, BoxProps, Heading, HStack, Stack, StackProps} from "@chakra-ui/react";
import {
  HoverMenuItem,
  HoverMenuItemHeading,
  HoverMenuItemText,
  HoverMenuList,
  HoverMenuSection,
  HoverMenuSeparator,
} from "../components/HoverMenu";
import {ReactNode} from "react";
import {Logo} from "../../Logo";

const AppIcon = ({size = "md", ...props}: {size?: "sm" | "md" | "lg"} & BoxProps) => {
  const w = {
    sm: 6,
    md: 8,
    lg: 12,
  }[size];

  const p = {
    sm: 1,
    md: 1.5,
    lg: 3,
  }[size];

  return (
    <Box w={w} h={w} p={p} rounded={size} flexShrink={0} {...props}>
      <Logo light w="full" h="full" />
    </Box>
  );
};

const App = ({icon, name, about, to}: {icon: ReactNode; name: string; about: string; to: string}) => (
  <HoverMenuItem className="group">
    {icon}
    <Stack gap={1}>
      <HoverMenuItemHeading to={to}>{name}</HoverMenuItemHeading>
      <HoverMenuItemText>{about}</HoverMenuItemText>
    </Stack>
  </HoverMenuItem>
);

const SectionHeading = ({children}: {children: ReactNode}) => (
  <HStack gap={1}>
    <Heading color="gray.400" size="xs" textTransform="uppercase">
      For
    </Heading>
    <Heading size="xs" textTransform="uppercase">
      {children}
    </Heading>
  </HStack>
);

const Solutions = (props: StackProps) => (
  <HoverMenuList {...props}>
    <Stack separator={<HoverMenuSeparator />} gap={4}>
      <HoverMenuSection heading={<SectionHeading>Audit &amp; VRM</SectionHeading>}>
        <App
          icon={<AppIcon bgGradient="blueBrand" />}
          name="Control Assurance"
          about="Automate design, implementation &amp; operational effectiveness testing"
          to="/control-assurance"
        />
        {/*<App
          icon={<AppIcon bgGradient="blueBrand" />}
          name="Risk Assessment Engine"
          about="AI-driven risk identification aligned to audit &amp; compliance frameworks"
          to="/risk-assessment-engine"
        />*/}
      </HoverMenuSection>
      {/*
      <HoverMenuSection heading={<SectionHeading>Customer assurance</SectionHeading>}>
        <App
          icon={<AppIcon bgGradient="showcase" />}
          name="Questionnaire Automation"
          about="Generate fast, consistent answers to DDQs, RFPs, &amp; compliance checks"
          to="/respond"
        />
        <App
          icon={<AppIcon bgGradient="showcase" />}
          name="Trust Center"
          about="This is another subtitle"
          to="/showcase"
        />
      </HoverMenuSection>*/}
    </Stack>
  </HoverMenuList>
);

export default Solutions;
